import { EquipmentType, RecipeType, StepZutatList } from "@/types/baseTypes";
import React, { useState } from "react";
import styles from "./RecipeSingleView.module.scss";
import RecipeImage from "./RecipeImage/RecipeImage";
import RecipeDifficultyInfo from "./RecipeDifficultyInfo/RecipeDifficultyInfo";
import RecipeVotingButtons from "./RecipeVotingButtons/RecipeVotingButtons";
import RecipeIngredientList from "./RecipeIngredientList/RecipeIngredientList";
import ShoppingListButton from "../ShoppingListButton/ShoppingListButton";
import {
  OptionsRecipeType,
  OptionsTopfiGraphicsType,
} from "@/types/OptionType";
import RecipeTopfi from "./RecipeTopfi/RecipeTopfi";
import CookingModeButton from "../CookingModeButton/CookingModeButton";
import CookingMode from "@/components/CookingMode/CookingMode";
import RecipeInstruction from "./RecipeInstruction/RecipeInstruction";
import PDFDownloadButton from "./PDFDownloadButton/PDFDownloadButton";
import RecipeDescription from "./RecipeDescription/RecipeDescription";
import RecipeModalButton from "../RecipeModalButton/RecipeModalButton";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { Post } from "@/wp/types/client";

interface RecipeSingleViewProps {
  recipeDetails: RecipeType;
  favCount: number;
  topfiGraphics: OptionsTopfiGraphicsType;
  ingredientsList: StepZutatList;
  isCookingMode: boolean;
  recipeOptions: OptionsRecipeType;
  equipmentList: EquipmentType[];
}

function RecipeSingleView({
  recipeDetails,
  favCount,
  topfiGraphics,
  ingredientsList,
  isCookingMode,
  recipeOptions,
  equipmentList,
}: RecipeSingleViewProps) {
  const [portionSize] = useState(recipeDetails.anzahl_portionen_big || 4);
  if (isCookingMode) {
    return (
      <CookingMode
        recipeDetails={recipeDetails}
        cookingOptions={recipeOptions.cooking_mode}
        ingredientsList={ingredientsList}
        portionSize={portionSize}
        topfiGraphics={topfiGraphics}
        equipmentList={equipmentList}
      />
    );
  }

  return (
    <>
      <Breadcrumbs
        breadcrumbPositon="is-justify-content-flex-start"
        parents={[
          { title: "Rezepte", url: "/rezepte", isEmptyParentPage: false },
        ]}
        post={
          {
            type: "page",
            slug: "recipe",
            title: { rendered: recipeDetails.rezept_titel },
          } as Post
        }
        extraClass={styles.breadcrumbs}
      />
      <section className="section is-gapless-top">
        <div className="container">
          <article
            className={`${styles.recipe} columns is-multiline is-centered`}
          >
            <div className="column is-12-tablet is-hidden-desktop">
              <RecipeImage recipeDetails={recipeDetails} />
            </div>

            <div className="column is-10-tablet is-5-desktop">
              <header>
                <h1 className="h1-pages">{recipeDetails.rezept_titel}</h1>
              </header>

              <RecipeVotingButtons
                favCount={favCount}
                recipeDetails={recipeDetails}
                className="is-hidden-desktop"
              />

              <RecipeDifficultyInfo recipeDetails={recipeDetails} />
              <RecipeDescription
                description={recipeDetails.rezept_beschreibung}
              />

              <RecipeIngredientList ingredientsList={ingredientsList} />
              <ShoppingListButton
                recipeId={recipeDetails.rezept_id}
                className="mx-auto"
                recipeTitle={recipeDetails.rezept_titel}
              />

              <RecipeTopfi
                topfiGraphics={topfiGraphics}
                recipe_topfi_text={recipeDetails.topfi_tipp}
              />
            </div>

            <div className="column is-10-tablet is-6-desktop is-offset-1-desktop">
              <div className="is-hidden-touch">
                <RecipeImage recipeDetails={recipeDetails} />
                <RecipeVotingButtons
                  favCount={favCount}
                  recipeDetails={recipeDetails}
                />
              </div>

              <div className={styles.buttons}>
                {equipmentList && equipmentList.length && (
                  <RecipeModalButton
                    modalType="recipe-tools"
                    label={"recipe_button_tool"}
                    icon="circleTool"
                  />
                )}

                {recipeDetails.rezept_tipp && (
                  <RecipeModalButton
                    modalType="recipe-tipp"
                    label={"recipe_button_tipps"}
                    icon="circleGoodToKnow"
                  />
                )}

                <CookingModeButton />
              </div>

              <RecipeInstruction recipeDetails={recipeDetails} />

              <section className={styles.buttons}>
                <CookingModeButton />
                <ShoppingListButton
                  recipeId={recipeDetails.rezept_id}
                  recipeTitle={recipeDetails.rezept_titel}
                />
                <PDFDownloadButton
                  pdfType="recipe"
                  printList={[{ item: recipeDetails, index: 0 }]}
                />
              </section>
            </div>
          </article>
        </div>
      </section>
    </>
  );
}

export default RecipeSingleView;
